import React, { forwardRef, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'

const useStyles = makeStyles<Theme, PropTypes>((theme: Theme) => ({
  button: {
    width: ({ width }) => width,
    marginTop: ({ mt }) => mt,
    marginBottom: ({ mb }) => mb,
    marginLeft: ({ ml }) => ml,
    marginRight: ({ mr }) => mr,

    height: ({ height }) => height || 40,
    padding: '10px 0',

    borderRadius: 4,

    fontSize: ({ fontSize }) => fontSize || 14,
    fontWeight: 500,
    lineHeight: 0,

    '&:hover': {
      background: theme.palette.secondary.light,
    },
    '&.MuiButton-contained.Mui-disabled': {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.secondary.main,
      opacity: 0.6,
    },
  },
  prefix: {
    fontSize: 18,
    fontWeight: 400,
    paddingRight: 10,
    lineHeight: 0,
  },
  text: {
    textTransform: 'none',
  },
}))

type PropTypes = {
  prefix?: string
  text: string
  width: number | string
  mt?: number | string
  mb?: number | string
  ml?: number | string
  mr?: number | string
  type?: string
  href?: string
  disabled?: boolean
  // eslint-disable-next-line
  onClick?: (event?: any) => void
  height?: number | string
  fontSize?: number
}

// eslint-disable-next-line react/display-name
export const GreenButton: React.FC<PropTypes> = forwardRef<HTMLButtonElement, PropTypes>(
  ({ prefix, text, width, mt, mb, ml, mr, type = 'submit', href, disabled, onClick, height, fontSize }, ref) => {
    const classes = useStyles({ prefix, text, width, mt, mb, ml, mr, type, href, height, fontSize })
    const history = useHistory()

    const goTo = useCallback(() => {
      history.push(`${href}`)
    }, [history, href])

    return (
      <Button
        ref={ref}
        disabled={disabled}
        variant="contained"
        type="submit"
        className={classes.button}
        onClick={href ? goTo : onClick}
      >
        {prefix && <span className={clsx(classes.prefix, 'material-icons')}>{prefix}</span>}
        <span className={classes.text}>{text}</span>
      </Button>
    )
  },
)
